import { render } from "./EmbeddedGenogramLegendColumn.vue?vue&type=template&id=bbc8e092"
import script from "./EmbeddedGenogramLegendColumn.vue?vue&type=script&lang=js"
export * from "./EmbeddedGenogramLegendColumn.vue?vue&type=script&lang=js"

import "./EmbeddedGenogramLegendColumn.vue?vue&type=style&index=0&id=bbc8e092&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__